import request from '@/utils/request'
/**
* 客户端资源表API
*
* @author Tu YongQi
* @since 2022/08/16
*/

/**
* 基础接口
*
* @type {string}
*/
const BASE_URL = '/system/sys-resources'

/**
* 分页查询接口
*
* @type {string}
*/
export const PAGE_URL = `${BASE_URL}/page`

/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function get(id: any) {
  return request({
    url: `${BASE_URL}/get/${id}`,
    method: 'get'
  })
}

/**
* 保存数据
*
* @param data 数据
* @returns {Promise}
*/
export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
* 更新数据
*
* @param data 数据
* @returns {Promise}
*/
export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

/**
* 删除数据
*
* @param idList ID数组
* @returns {Promise}
*/
export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}

/**
* 所有启用的资源
*
* @returns {Promise}
*/
export function listEnableResources() {
  return request({
    url: BASE_URL + '/listEnableResources',
    method: 'get'
  })
}
